/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type FinancialAggregatedNumber = "accruedDeferred" | "actualCost" | "actualLockedRevenue" | "actualMargin" | "actualOpenRevenue" | "actualProfit" | "actualRevenue" | "actualRevenueMargin" | "actualRevenueProfit" | "allActualTimeAndExpenses" | "allForecastTimeAndExpensesToComplete" | "allPlannedTimeAndExpenses" | "allTotalTimeAndExpensesAtCompletion" | "allocationMinutes" | "baselineCost" | "baselineMargin" | "baselineMinutes" | "baselineProfit" | "baselineRevenue" | "baselineTimeAndExpenses" | "baselineVsActualCost" | "baselineVsActualMargin" | "baselineVsActualProfit" | "baselineVsActualRevenue" | "baselineVsActualRevenueMargin" | "baselineVsActualRevenueProfit" | "baselineVsActualRevenueRecognition" | "baselineVsBillableActualTimeAndExpenses" | "baselineVsBillableTotalTimeAndExpensesAtCompletion" | "baselineVsForecastCost" | "baselineVsForecastMinutes" | "baselineVsForecastProfit" | "baselineVsForecastRevenue" | "baselineVsRegisteredMinutes" | "baselineVsTotalCostAtCompletion" | "baselineVsTotalMarginAtCompletion" | "baselineVsTotalProfitAtCompletion" | "baselineVsTotalRevenueAtCompletion" | "baselineVsTotalRevenueMarginAtCompletion" | "baselineVsTotalRevenueProfitAtCompletion" | "baselineVsTotalTimeAtCompletion" | "billableActualMinutes" | "billableActualTimeAndExpenses" | "billableForecastTimeAndExpensesToComplete" | "billablePlannedTimeAndExpenses" | "billableTime" | "billableTotalTimeAndExpensesAtCompletion" | "estimatedCost" | "estimatedCostPercentage" | "expenseCostPercentage" | "expenseRevenuePercentage" | "forecastCost" | "forecastCostToComplete" | "forecastLockedRevenueToComplete" | "forecastMargin" | "forecastMarginToComplete" | "forecastMinutes" | "forecastOpenRevenueToComplete" | "forecastProfit" | "forecastProfitToComplete" | "forecastRevenue" | "forecastRevenueMarginToComplete" | "forecastRevenueProfitToComplete" | "forecastTimeToComplete" | "forecastVsScopeApprovedMinutes" | "invoiced" | "nonBillableActualMinutes" | "nonBillableActualTimeAndExpenses" | "nonBillableForecastTimeAndExpensesToComplete" | "nonBillablePlannedTimeAndExpenses" | "nonBillableTotalTimeAndExpensesAtCompletion" | "paid" | "planVsActualCost" | "planVsActualMargin" | "planVsActualProfit" | "planVsActualRevenue" | "planVsActualRevenueMargin" | "planVsActualRevenueProfit" | "planVsActualRevenueRecognition" | "planVsBillableActualTimeAndExpenses" | "planVsForecastCost" | "planVsForecastProfit" | "planVsForecastRevenue" | "planVsTotalBillableTimeAndExpensesAtCompletion" | "planVsTotalCostAtCompletion" | "planVsTotalMarginAtCompletion" | "planVsTotalProfitAtCompletion" | "planVsTotalRevenueAtCompletion" | "planVsTotalRevenueMarginAtCompletion" | "planVsTotalRevenueProfitAtCompletion" | "plannedCost" | "plannedMargin" | "plannedProfit" | "plannedRevenue" | "plannedRevenueMargin" | "plannedRevenueProfit" | "projectedTotalRevenueVsProjectedTotalBillableValueOfService" | "projectedTotalRevenueVsProjectedTotalValueOfService" | "recognitionActualProfit" | "recognitionActualProfitPercentage" | "recognitionAmount" | "recognitionForecastRevenue" | "recognitionLockedProfit" | "recognitionLockedProfitPercentage" | "recognitionLockedRevenue" | "recognitionOpenRevenue" | "recognitionPercentage" | "recognitionProfit" | "recognitionProfitPercentage" | "registeredMinutes" | "registeredVsScopeApprovedMinutes" | "remainingCost" | "remainingMargin" | "remainingMinutes" | "remainingProfit" | "remainingRevenue" | "retainerPeriodRolloverMinutes" | "retainerPeriodRolloverPrice" | "retainerPeriodTargetMinutes" | "retainerPeriodTargetPrice" | "scopeApprovedMinutes" | "scopeApprovedVsForecastMinutes" | "scopeApprovedVsRegisteredMinutes" | "scopeApprovedVsTotalTimeAtCompletion" | "scopeTotalMinutes" | "suggestedProfit" | "suggestedProfitPercentage" | "suggestedRevenue" | "suggestedRevenuePercentage" | "surplus" | "surplusPercentage" | "totalActualRevenueRecognition" | "totalCostAtCompletion" | "totalForecastRevenueToComplete" | "totalMarginAtCompletion" | "totalProfitAtCompletion" | "totalRevenueMarginAtCompletion" | "totalRevenueProfitAtCompletion" | "totalRevenueRecognition" | "totalTimeAtCompletion" | "totalTimeAtCompletionVsScopeApprovedMinutes" | "%future added value";
export type GLOBAL_FILTER_CONTEXT = "INVOICES" | "LABELS" | "PEOPLE" | "PLACEHOLDERS" | "PROJECTS" | "RESOURCES" | "SKILLS" | "TASKS" | "TIME_REGS" | "%future added value";
export type GLOBAL_FILTER_FIELD = "APPROVAL_STATUS" | "ASSIGNED" | "ASSIGNED_SELF" | "BILLABLE" | "BILLABLE_TIME_REG" | "BILL_FROM" | "BILL_TO" | "BLOCKED" | "BUG" | "CLIENT" | "CLIENT_GUEST_USERS" | "CLIENT_TIME_REG" | "COMPANY_TASK_ID" | "CONTACT" | "CREATED_AT" | "DEADLINE" | "DEPARTMENT" | "DEPARTMENT_TIME_REG" | "DEPENDENCIES" | "DESCRIPTION" | "END_DATE" | "END_DATE_PROJECT" | "END_DATE_TIME_REG" | "FILTER_BY_TIME_REG_SETTINGS" | "FOLLOWER" | "FORECAST" | "HIGH_PRIORITY" | "INTERNAL_TIME" | "INTERNAL_TIME_REG" | "INVOICED" | "LABELS" | "LABEL_TIME_REG" | "NAME" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "NON_TASK_TIME_REG" | "NO_CONTACT" | "OWNER" | "PERMISSION_LEVEL" | "PERSON" | "PERSON_TIME_REG" | "PHASE_CATEGORY" | "PHASE_TIME_REG" | "PRIORITY_LEVEL" | "PROGRAM" | "PROJECT" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "PROJECT_FOLLOWER" | "PROJECT_GROUP" | "PROJECT_GROUP_SPRINT" | "PROJECT_GROUP_STATUS" | "PROJECT_LABELS" | "PROJECT_MANUAL_PROGRESS" | "PROJECT_OWNER" | "PROJECT_PERSON" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_STAGE" | "PROJECT_STATUS" | "PROJECT_TIME_REG" | "PROJECT_WIN_CHANCE" | "RATE_CARD" | "RECENT_ACTIVITY" | "RECENT_TASK_ACTIVITY" | "RECENT_TIME" | "REMAINING" | "RETAINER_PERIOD" | "ROLE" | "ROLE_TIME_REG" | "SET_DONE_AT" | "SKILL" | "SPRINT_CATEGORY" | "SPRINT_TIME_REG" | "STARRED" | "START_DATE" | "START_DATE_PROJECT" | "START_DATE_TIME_REG" | "STATUS" | "SUB_TASKS" | "TASK" | "TASK_APPROVED" | "TASK_HIERARCHY" | "TASK_LEVEL" | "TASK_TIME_REG" | "TEAM" | "TEAM_MEMBER" | "TEAM_TIME_REG" | "TIME_OFF" | "TIME_OFF_TIME_REG" | "TIME_REGS" | "UPDATED_AT" | "WITH_TASKS" | "WITH_TIME_REG" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "ALL_IN" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "IN" | "IS" | "IS_ALL" | "IS_NOT" | "IS_NOT_ALL" | "LESS" | "LESS_OR_EQUAL" | "NOT_ALL_IN" | "NOT_IN" | "%future added value";
export type TaskSearchQueryType = {
    filters?: Array<GlobalSearchFilterType | null> | null | undefined;
};
export type GlobalSearchFilterType = {
    field?: GLOBAL_FILTER_FIELD | null | undefined;
    operator?: GLOBAL_FILTER_OPERATOR | null | undefined;
    value?: Array<string | null> | null | undefined;
    context?: GLOBAL_FILTER_CONTEXT | null | undefined;
    filters?: Array<GlobalSearchFilterType | null> | null | undefined;
    logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null | undefined;
};
export type MonthByMonthProjectLoader_QueryVariables = {
    startYear: number;
    startMonth: number;
    startDay: number;
    endYear: number;
    endMonth: number;
    endDay: number;
    searchQuery: TaskSearchQueryType;
    timeSearchQuery: TaskSearchQueryType;
    expenseSearchQuery: TaskSearchQueryType;
    pageSize: number;
    cursor?: string | null | undefined;
    selectedSingleValue: FinancialAggregatedNumber;
    ignoreBaselineWinChance?: boolean | null | undefined;
    excludeOpportunityActuals?: boolean | null | undefined;
};
export type MonthByMonthProjectLoader_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"MonthByMonthProjectLoader_viewer">;
    } | null;
};
export type MonthByMonthProjectLoader_Query = {
    readonly response: MonthByMonthProjectLoader_QueryResponse;
    readonly variables: MonthByMonthProjectLoader_QueryVariables;
};



/*
query MonthByMonthProjectLoader_Query(
  $startYear: Int!
  $startMonth: Int!
  $startDay: Int!
  $endYear: Int!
  $endMonth: Int!
  $endDay: Int!
  $searchQuery: TaskSearchQueryType!
  $timeSearchQuery: TaskSearchQueryType!
  $expenseSearchQuery: TaskSearchQueryType!
  $pageSize: Int!
  $cursor: String
  $selectedSingleValue: FinancialAggregatedNumber!
  $ignoreBaselineWinChance: Boolean
  $excludeOpportunityActuals: Boolean
) {
  viewer {
    actualPersonId
    component(name: "project_portfolio_month_by_month_project_loader")
    ...MonthByMonthProjectLoader_viewer_1rjyav
    id
  }
}

fragment DeprecatedProjectIndicatorJS_project on ProjectType {
  name
  companyProjectId
  customProjectId
  projectColor
}

fragment MonthByMonthProjectLoader_viewer_1rjyav on Viewer {
  id
  company {
    currency
    financialBasedProjects(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], first: $pageSize, after: $cursor, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals) {
      edges {
        node {
          id
          companyProjectId
          ...DeprecatedProjectIndicatorJS_project
          name
          readOnlyAccess
          fullAccessToProject
          projectColor
          useBaseline
          status
          baselineWinChance
          priorityLevel {
            id
            name
          }
          budgetType
          budgetBaseCurrency
          defaultPeriodBudgetType
          projectStartDay
          projectStartMonth
          projectStartYear
          projectEndDay
          projectEndMonth
          projectEndYear
          estimationUnit
          completion
          rateCard {
            id
            name
            currency
            parentRateCardId
          }
          client {
            id
            name
            logoId
            logoDefaultId
          }
          projectLabels(first: 1000) {
            edges {
              node {
                label {
                  name
                  color
                  id
                }
                id
              }
            }
          }
          projectPersons(first: 1000000, contactsOnly: true) {
            edges {
              node {
                id
                isContactPerson
                person {
                  id
                  fullName
                  firstName
                  lastName
                  profilePictureId
                  profilePictureDefaultId
                  initials
                }
              }
            }
          }
          currentProjectStatus {
            id
            color
            description
            person {
              id
              firstName
              lastName
              fullName
              profilePictureId
            }
          }
          aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)
          timeAggregatedFinancialNumbers: aggregatedFinancialNumbers(searchQuery: $timeSearchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], fetchOwnData: true, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)
          expenseAggregatedFinancialNumbers: aggregatedFinancialNumbers(searchQuery: $expenseSearchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], fetchOwnData: true, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)
          fixedPriceLocks(first: 1000) {
            edges {
              node {
                id
                startDate
                endDate
                locked
              }
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startYear",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startMonth",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDay",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endYear",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endMonth",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endDay",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchQuery",
    "type": "TaskSearchQueryType!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "timeSearchQuery",
    "type": "TaskSearchQueryType!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "expenseSearchQuery",
    "type": "TaskSearchQueryType!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageSize",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "selectedSingleValue",
    "type": "FinancialAggregatedNumber!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ignoreBaselineWinChance",
    "type": "Boolean"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeOpportunityActuals",
    "type": "Boolean"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "project_portfolio_month_by_month_project_loader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"project_portfolio_month_by_month_project_loader\")"
},
v3 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v4 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v5 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v6 = {
  "kind": "Variable",
  "name": "excludeOpportunityActuals",
  "variableName": "excludeOpportunityActuals"
},
v7 = {
  "kind": "Variable",
  "name": "ignoreBaselineWinChance",
  "variableName": "ignoreBaselineWinChance"
},
v8 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v9 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v10 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v11 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v14 = {
  "kind": "Literal",
  "name": "aggregateLevel",
  "value": "MONTH"
},
v15 = {
  "items": [
    {
      "kind": "Variable",
      "name": "aggregates.0",
      "variableName": "selectedSingleValue"
    }
  ],
  "kind": "ListValue",
  "name": "aggregates"
},
v16 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v14/*: any*/),
  (v15/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "pageSize"
  },
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v24 = {
  "kind": "Literal",
  "name": "fetchOwnData",
  "value": true
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MonthByMonthProjectLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "Variable",
                "name": "expenseSearchQuery",
                "variableName": "expenseSearchQuery"
              },
              (v7/*: any*/),
              {
                "kind": "Variable",
                "name": "pageSize",
                "variableName": "pageSize"
              },
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "selectedSingleValue",
                "variableName": "selectedSingleValue"
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "kind": "Variable",
                "name": "timeSearchQuery",
                "variableName": "timeSearchQuery"
              }
            ],
            "kind": "FragmentSpread",
            "name": "MonthByMonthProjectLoader_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MonthByMonthProjectLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "financialBasedProjects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "companyProjectId",
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "customProjectId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectColor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "readOnlyAccess",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullAccessToProject",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "useBaseline",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineWinChance",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PriorityLevel",
                            "kind": "LinkedField",
                            "name": "priorityLevel",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "budgetType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "budgetBaseCurrency",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "defaultPeriodBudgetType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectStartDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectStartMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectStartYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectEndDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectEndMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectEndYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "estimationUnit",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "completion",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RateCard",
                            "kind": "LinkedField",
                            "name": "rateCard",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v17/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "parentRateCardId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Client",
                            "kind": "LinkedField",
                            "name": "client",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "logoId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "logoDefaultId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v18/*: any*/),
                            "concreteType": "ProjectLabelTypeConnection",
                            "kind": "LinkedField",
                            "name": "projectLabels",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectLabelTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectLabel",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Label",
                                        "kind": "LinkedField",
                                        "name": "label",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          (v19/*: any*/),
                                          (v12/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v12/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "projectLabels(first:1000)"
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "contactsOnly",
                                "value": true
                              },
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1000000
                              }
                            ],
                            "concreteType": "ProjectPersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "projectPersons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectPersonTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectPerson",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isContactPerson",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "kind": "LinkedField",
                                        "name": "person",
                                        "plural": false,
                                        "selections": [
                                          (v12/*: any*/),
                                          (v20/*: any*/),
                                          (v21/*: any*/),
                                          (v22/*: any*/),
                                          (v23/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "profilePictureDefaultId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "initials",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "projectPersons(contactsOnly:true,first:1000000)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectStatus",
                            "kind": "LinkedField",
                            "name": "currentProjectStatus",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "description",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Person",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v20/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "aggregatedFinancialNumbers",
                            "storageKey": null
                          },
                          {
                            "alias": "timeAggregatedFinancialNumbers",
                            "args": [
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v24/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "Variable",
                                "name": "searchQuery",
                                "variableName": "timeSearchQuery"
                              },
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "aggregatedFinancialNumbers",
                            "storageKey": null
                          },
                          {
                            "alias": "expenseAggregatedFinancialNumbers",
                            "args": [
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v24/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "Variable",
                                "name": "searchQuery",
                                "variableName": "expenseSearchQuery"
                              },
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "aggregatedFinancialNumbers",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v18/*: any*/),
                            "concreteType": "ProjectFixedPriceLockTypeConnection",
                            "kind": "LinkedField",
                            "name": "fixedPriceLocks",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectFixedPriceLockTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectFixedPriceLockType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "startDate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "endDate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "locked",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "fixedPriceLocks(first:1000)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "filters": [
                  "searchQuery",
                  "startYear",
                  "startMonth",
                  "startDay",
                  "endYear",
                  "endMonth",
                  "endDay",
                  "aggregateLevel",
                  "aggregates",
                  "ignoreBaselineWinChance",
                  "excludeOpportunityActuals"
                ],
                "handle": "connection",
                "key": "Company_financialBasedProjects",
                "kind": "LinkedHandle",
                "name": "financialBasedProjects"
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "MonthByMonthProjectLoader_Query",
    "operationKind": "query",
    "text": "query MonthByMonthProjectLoader_Query(\n  $startYear: Int!\n  $startMonth: Int!\n  $startDay: Int!\n  $endYear: Int!\n  $endMonth: Int!\n  $endDay: Int!\n  $searchQuery: TaskSearchQueryType!\n  $timeSearchQuery: TaskSearchQueryType!\n  $expenseSearchQuery: TaskSearchQueryType!\n  $pageSize: Int!\n  $cursor: String\n  $selectedSingleValue: FinancialAggregatedNumber!\n  $ignoreBaselineWinChance: Boolean\n  $excludeOpportunityActuals: Boolean\n) {\n  viewer {\n    actualPersonId\n    component(name: \"project_portfolio_month_by_month_project_loader\")\n    ...MonthByMonthProjectLoader_viewer_1rjyav\n    id\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment MonthByMonthProjectLoader_viewer_1rjyav on Viewer {\n  id\n  company {\n    currency\n    financialBasedProjects(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], first: $pageSize, after: $cursor, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals) {\n      edges {\n        node {\n          id\n          companyProjectId\n          ...DeprecatedProjectIndicatorJS_project\n          name\n          readOnlyAccess\n          fullAccessToProject\n          projectColor\n          useBaseline\n          status\n          baselineWinChance\n          priorityLevel {\n            id\n            name\n          }\n          budgetType\n          budgetBaseCurrency\n          defaultPeriodBudgetType\n          projectStartDay\n          projectStartMonth\n          projectStartYear\n          projectEndDay\n          projectEndMonth\n          projectEndYear\n          estimationUnit\n          completion\n          rateCard {\n            id\n            name\n            currency\n            parentRateCardId\n          }\n          client {\n            id\n            name\n            logoId\n            logoDefaultId\n          }\n          projectLabels(first: 1000) {\n            edges {\n              node {\n                label {\n                  name\n                  color\n                  id\n                }\n                id\n              }\n            }\n          }\n          projectPersons(first: 1000000, contactsOnly: true) {\n            edges {\n              node {\n                id\n                isContactPerson\n                person {\n                  id\n                  fullName\n                  firstName\n                  lastName\n                  profilePictureId\n                  profilePictureDefaultId\n                  initials\n                }\n              }\n            }\n          }\n          currentProjectStatus {\n            id\n            color\n            description\n            person {\n              id\n              firstName\n              lastName\n              fullName\n              profilePictureId\n            }\n          }\n          aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)\n          timeAggregatedFinancialNumbers: aggregatedFinancialNumbers(searchQuery: $timeSearchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], fetchOwnData: true, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)\n          expenseAggregatedFinancialNumbers: aggregatedFinancialNumbers(searchQuery: $expenseSearchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue], fetchOwnData: true, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals)\n          fixedPriceLocks(first: 1000) {\n            edges {\n              node {\n                id\n                startDate\n                endDate\n                locked\n              }\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '56dde26508c2411862ae112cfbdee985';
export default node;
